import type { Channel } from 'stream-chat';
import { CHAT_LABEL_UNKNOWN_USER } from '@features/components/Chat/constants';
import type { ChatUserData } from '../CustomChannelHeader/ChannelMenu/interface';

export const getChannelMembers = (channel?: Channel): ChatUserData[] =>
  channel
    ? Object.values(channel.state.members).map((m) => ({
        id: m.user_id!,
        name: m.user?.name || CHAT_LABEL_UNKNOWN_USER,
        image: m.user?.image || '',
        online: !!m.user?.online,
        role: m.user?.role || '',
      }))
    : [];
